const resolveCanonicalReviewText = (row = {}) => String(
  row?.body
  || row?.note
  || row?.text
  || row?.content
  || row?.details
  || row?.description
  || row?.summary
  || row?.value
  || row?.sourceText
  || row?.originalText
  || row?.rawText
  || ''
).trim();

export const normalizeBackendCaptureReviewRow = (row = {}, {
  parserMode = 'backend_ai',
  sourceMode = 'backend_ai',
  inputMode = 'backend_ai',
  rawText = '',
  backendSource = '',
  parsedBy = '',
  reviewNeeded = null,
} = {}) => {
  if (!row || typeof row !== 'object') {
    return row;
  }

  const canonicalText = resolveCanonicalReviewText(row);
  const canonicalCategory = String(row?.category || row?.cat || 'log').trim().toLowerCase();
  const canonicalTitle = String(row?.title || row?.titlePrefix || '').trim();
  const canonicalDate = row?.date instanceof Date
    ? new Date(row.date)
    : (row?.date ? new Date(row.date) : null);
  const canonicalDateValid = canonicalDate instanceof Date && !Number.isNaN(canonicalDate.getTime());
  const canonicalTime = String(row?.time || row?.localTime || '').trim() || null;
  const timeBucket = String(row?.timeBucket || row?.metadata?.timeBucket || '').trim();
  const timeInferred = Boolean(row?.timeInferred || row?.metadata?.timeInferred || timeBucket);
  const timeSource = String(row?.timeSource || row?.metadata?.timeSource || (timeInferred ? 'inferred' : (canonicalTime ? 'explicit' : 'missing'))).trim() || 'missing';
  const sourceText = String(row?.sourceText || row?.originalText || rawText || canonicalText || '').trim();
  const originalText = String(row?.originalText || row?.sourceText || rawText || canonicalText || '').trim();
  const confidence = row?.confidence || row?.reviewConfidence || row?.metadata?.confidence || 'low';

  const metadata = {
    ...(row?.metadata || {}),
    canonicalRowVersion: row?.canonicalRowVersion || 1,
    parserMode: row?.parserMode || parserMode,
    sourceMode: row?.sourceMode || sourceMode,
    inputMode: row?.inputMode || inputMode,
    rawText: row?.rawText || rawText || sourceText || originalText || '',
    rawSourceText: row?.rawSourceText || rawText || sourceText || originalText || '',
  };

  if (backendSource) {
    metadata.backendSource = backendSource;
  }

  if (parsedBy) {
    metadata.parsedBy = parsedBy;
  }

  if (reviewNeeded !== null && reviewNeeded !== undefined) {
    metadata.reviewNeeded = Boolean(reviewNeeded);
  }

  if (row?.confidence || row?.reviewConfidence || row?.metadata?.confidence) {
    metadata.confidence = confidence;
  }

  return {
    ...row,
    category: canonicalCategory,
    title: canonicalTitle || row?.title || row?.titlePrefix || canonicalCategory,
    titlePrefix: String(row?.titlePrefix || row?.label || canonicalCategory || '').trim(),
    body: canonicalText,
    note: canonicalText,
    text: canonicalText,
    content: canonicalText,
    details: canonicalText,
    description: canonicalText,
    summary: canonicalText,
    value: canonicalText,
    date: canonicalDateValid ? canonicalDate : row?.date || null,
    entryDate: row?.entryDate
      || (canonicalDateValid ? canonicalDate.toDateString() : null)
      || null,
    time: canonicalTime,
    localTime: row?.localTime || canonicalTime || null,
    timeSource,
    timeBucket,
    timeInferred,
    timeInferenceReason: String(row?.timeInferenceReason || row?.metadata?.timeInferenceReason || timeBucket || '').trim(),
    sourceText,
    originalText,
    parserMode: row?.parserMode || parserMode,
    sourceMode: row?.sourceMode || sourceMode,
    inputMode: row?.inputMode || inputMode,
    rawText: row?.rawText || rawText || sourceText || canonicalText || '',
    rawSourceText: row?.rawSourceText || rawText || sourceText || canonicalText || '',
    source: row?.source || backendSource || parsedBy || 'backend_ai',
    mode: row?.mode || inputMode,
    confidence,
    reviewConfidence: row?.reviewConfidence || confidence,
    reviewConfidenceLabel: row?.reviewConfidenceLabel || '',
    reviewConfidenceReasons: Array.isArray(row?.reviewConfidenceReasons) ? row.reviewConfidenceReasons : [],
    parsedObservation: Boolean(row?.parsedObservation),
    parsedSourceCategory: row?.parsedSourceCategory || canonicalCategory,
    parsedSourceConfidence: row?.parsedSourceConfidence || confidence,
    canonicalRowVersion: row?.canonicalRowVersion || 1,
    metadata,
  };
};

export const normalizeBackendCaptureReviewRows = (rows = [], options = {}) => (
  Array.isArray(rows)
    ? rows.map((row) => normalizeBackendCaptureReviewRow(row, options))
    : []
);
